var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'tooltip',
        _vm.color ? 'bg-' + _vm.color + ' border-' + _vm.color : '',
        _vm.position,
        _vm.noWrap ? 'no-wrap' : '',
        _vm.relative ? 'relative' : '' ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }